export default '@lomray/vite-ssr-boost';
